import React, { Component } from "react";
import { Row, Col, Button, ListGroup, Form, Alert, Modal } from "react-bootstrap";


import "containers/common/List.css";

import ReactTable from "react-table";
import 'react-table/react-table.css';
//import Moment from "moment";
import DatePicker from "react-datepicker";
import Select from 'react-select';

export default class PropertyClassificationList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "propertyClassifications",
            dataRecord: "propertyClassifications",
            dataSetPrimaryKey: "property_classification_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }

       

        this.setState({ isLoading: false });      
    }



    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }





    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        if (event.detail !== 0) {
            let data = [...this.props.data];
            var r = window.confirm("Are you sure you want to delete this record?");
            if (r === true) {
                console.log(cellInfo);

                data[cellInfo.index].archived_date = new Date();
                await this.handleDataSave(data[cellInfo.index]).then((result) => {
                    data.splice(cellInfo.index, 1);
                    this.props.updateTableState(data, this.state.dataSet);
                }
                )
            };
        }
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleClassificationChange = (cellInfo, event) => {
        let data = [...this.props.data];
        console.log(event);
        data[cellInfo.index][cellInfo.column.id] = event.value;
        data[cellInfo.index].classification = event.label;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.props.updateTableState(data, this.state.dataSet);

    }


    addRecord = async event => {
        let data = [...this.props.data];

        //Minimum record to create (all not nulls populated)
        data.push({
            property_id: this.props.filter.propertyid,
            classification_code: "",
            classification: "",
            sort_order: this.props.data.length+1,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }



    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if (["sort_order"].indexOf(cellInfo.column.id) > 0) {
            return (
                <input
                    onChange={this.handleInputChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="number"
                    className="no-border form-control"
                    value={cellValue}
                    pattern="[0-9]*.[0-9]{2}"
                />
            );
        }

        if (cellInfo.column.id === "classification_code") {
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: this.props.classificationOptions.find(o => o.value === cellValue).label }}
                    onChange={this.handleClassificationChange.bind(null, cellInfo)}
                    options={this.props.classificationOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Select
                   
                    onChange={this.handleClassificationChange.bind(null, cellInfo)}
                    options={this.props.classificationOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
        }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }



    

    renderTable(data) {
        const columns = [

            {
                id: 'property_classification_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'property_classification_id' 

        }, {
                id: 'classification_code',
                Header: 'Classification',
                accessor: 'classification_code',
                Cell: this.renderEditable

            },
            {
                id: 'sort_order',
                Header: 'Sort Order',
                accessor: 'sort_order',
                maxWidth: 85,
                Cell: this.renderEditable

            },
            {
                Header: '',
                accessor: 'property_classification_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }

    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>

                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.classification}>
                            {(d.sort_order.toString() + ") ") + d.classification}
                        </ListGroup.Item>

                        : ""
            );
        }
    }

    
    renderComponent() {
        return (
            <div className="propertyclassifications">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.props.controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >

                        <Button variant="secondary" size="sm" onClick={this.addRecord}

                        >Add</Button>




                    </Col>
                </Row>}

                <Form.Row  className="show-Container">
                        <Col sm={12} md={12} lg={12}>                        
                        {!this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.renderList(this.props.data)}
                        </Col>
                </Form.Row >
       

            </div>
        );
    }
  render() {
    return (

        <div className="PropertyClassificationList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
